import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  fareAccessTab: {
    margin: "4px 0 320px 0",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "0px 0px",
    }
  },
  fareAccessDetails:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
    marginTop: "32px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display:"grid",
    }
  },
  btnContainer:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginTop: "15px"
    }
  },
  title:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom:"4px",
    color: colors.lightBlack,
  },
  description:{
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "20px"
    }
  },
  buttonCancel:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    marginRight:"12px",
  },
  button:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
  },
  dividerContainer:{
    display: "flex",
    alignItems: "center",
  },
  border:{
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px"
  },
  formContainer:{
    width: "fit-content",
    marginBottom: "30px"
  },

  toggleContainer:{
    marginBottom:"16px",
  },
  selectStateGovermentField: {
    width: "400px",
    minWidth: "400px",
    marginTop: "20px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& svg": {
      marginLeft: "-10px",
      fill: colors.grey,
    },
  },
  stateFare:{
    marginTop:"8px",
    marginLeft: "44px",
  },
  valueContainer:{
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    "& .input":{
      color:colors.white,
    },
    "& .data-value":{

    }
  },
  placeholderStyle:{
    marginLeft: "4px",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "400",
    color: colors.lightBlack,
  },
  closeIconStyle:{
    cursor: "pointer",
    display: "flex",
    marginRight: "4px",
    padding: "2px",
  },
  inputContainer: {
    marginBottom: "20px",
    marginTop:"8px",
    marginLeft: "44px",
    display: "flex",
    flexDirection: "column",
    "& input": {
      height: "40px",
      width: "200px",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& .input-error": {
      border: "1px solid " + colors.mediumRed,
      backgroundSize: "16px 16px",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
      backgroundImage: `url(${checkIconRed})`
    },
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  textErrorStyle: {
    fontSize: "14px",
    fontWeight:"400",
    color: colors.red,
    marginTop: "6px"
  },
  toggle: {
    display:"flex",
    alignItems:"center",
    "& span":{
      marginLeft:"8px",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: theme.toggle.color
    },
    "& .react-toggle--checked": {
      "& .react-toggle-thumb": {
        left: "18px",
      },
      "& .react-toggle-track": {
        backgroundColor: theme.toggle.checked.backgroundColor,
        "&:hover": {
          backgroundColor: theme.toggle.checked.hover.backgroundColor
        }
      }
    },
    "& .react-toggle": {
      "& .react-toggle-track": {
        width: "36px",
        height: "20px",
        backgroundColor: theme.toggle.unchecked.backgroundColor,
        "&:hover": {
          backgroundColor: theme.toggle.unchecked.hover.backgroundColor
        }
      },
    },
    "& .react-toggle-thumb": {
      backgroundColor: theme.toggle.thumbColor,
      left: "2px",
      width: "16px",
      height: "16px",
      top: "2px",
      border: "none",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1)",
      filter: "drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06)) drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.10))"
    },
  },
  contractDetailsLink: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    color: colors.hoverAS,
    marginLeft: "44px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none"
    }
  },
      errorContentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    borderRadius: "8px",
    marginTop: "20px",
  },
  errorTitle: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    marginBottom: "8px",
    color: colors.lightBlack,
  },
  errorText: {
    fontSize: "14px",
    textAlign: "center",
  },
  closeButton: {
    fontWeight: "600",  
    fontSize: "14px",
    lineHeight: "20px",
    marginLeft: "12px",
  },
  personalDetails:{
    color: colors.grey,
    fontSize: "14px"
  }
}));

export default styles;

